import React from 'react';
import { Circle, Moon } from 'lucide-react';
import { SpaceStatus } from '../types/space';
interface StatusIndicatorProps {
  status: SpaceStatus;
}
export function StatusIndicator({
  status
}: StatusIndicatorProps) {
  if (status === 'active') {
    return <div className="flex items-center space-x-2 bg-green-50 px-2 py-1 rounded-full border border-green-100" data-id="element-241">
        <span className="relative flex h-2 w-2" data-id="element-242">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-243"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-244"></span>
        </span>
        <span className="text-xs font-medium text-green-700" data-id="element-245">Active</span>
      </div>;
  }
  if (status === 'planning') {
    return <div className="flex items-center space-x-2 bg-gray-50 px-2 py-1 rounded-full border border-gray-200" data-id="element-246">
        <div className="h-2 w-2 rounded-full bg-gray-400" data-id="element-247" />
        <span className="text-xs font-medium text-gray-600" data-id="element-248">Planning</span>
      </div>;
  }
  return <div className="flex items-center space-x-2 bg-gray-50 px-2 py-1 rounded-full border border-gray-200" data-id="element-249">
      <Moon className="h-3 w-3 text-gray-400" data-id="element-250" />
      <span className="text-xs font-medium text-gray-600" data-id="element-251">Sleeping</span>
    </div>;
}